export function shouldFetchEligibilityReasons({
  isOpening,
  hasCachedData,
  isLoading
}) {
  return Boolean(isOpening && !hasCachedData && !isLoading)
}
